import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ClericalQuoteCard from './clericalQuoteCard';
import DriverQuoteCard from './driverQuoteCard';
import { getQuote } from './operations';
import { Button, SubHeader } from '../../../components';
import ClericalQuoteDocument from '../GenerateQuote/Clerical/clericalPDF';
import DriversQuoteDocument from '../GenerateQuote/Drivers/driversPDF';

const ViewQuote = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { quoteId } = useParams();
  const { selectedQuote, loading } = useSelector(state => state.viewQuote);
  const { subHeaderText } = useSelector(state => state.quoteEngine);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    getQuote(dispatch, quoteId);
  }, [quoteId]);

  const handleSetMounted = () => {
    setMounted(true);
  };

  useEffect(() => {
    setTimeout(() => {
      handleSetMounted();
    }, 3000);
  }, []);

  if (selectedQuote !== null && !loading) {
    return (
      <Container fluid>
        <SubHeader
          text={subHeaderText}
          buttons={[
            { icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') },
            { text: 'MY QUOTES', onPress: () => navigate('/quote-engine/my-quotes') },
          ]}
          popoverTitle="Need help with your quote?"
        />
        <Row>
          <Col className="p-0">
            {selectedQuote && mounted && (
              <PDFDownloadLink
                document={
                  selectedQuote?.quoteType?.toLowerCase() === 'clerical' ? (
                    <ClericalQuoteDocument quote={selectedQuote} />
                  ) : (
                    <DriversQuoteDocument quote={selectedQuote} />
                  )
                }
                fileName={`quote_${selectedQuote?.quoteId}.pdf`}>
                {({ scopedLoading, error }) => (
                  <Button variant="primary" disabled={error || scopedLoading} className="mb-3" text="Download">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      hidden={!scopedLoading}
                    />
                  </Button>
                )}
              </PDFDownloadLink>
            )}
          </Col>
        </Row>
        <Row>
          <Col className="border border-light rounded shadow-sm">
            {selectedQuote?.quoteType?.toLowerCase() === 'clerical' ? (
              <ClericalQuoteCard quote={selectedQuote} />
            ) : (
              <DriverQuoteCard quote={selectedQuote} />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
  return loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null;
};

export default ViewQuote;
